<template>
    <div class="login-layout">
        <form class="m-auto p-4 from-layout">
            <h3>لوحة التحكم</h3>

            <div id="status-layout"></div>
            <input type="email" v-model="email" class="form-control my-2" placeholder="البريد الالكتروني">
            <input type="password" v-model="password" class="form-control my-2" placeholder="كلمة المرور">
            <button type="button" @click="login" class="btn btn-success">تسجيل الدخول</button>
        </form>
    </div>
</template>

<style scoped>
    .login-layout{
        height: 80vh;
        display: flex;
    }

    .from-layout{
        width: 35%;
        background: #fbfbfb;
        border: 1px solid transparent;
        border-radius: 13px;
        box-shadow: 0px 0px 12px #d6d6d67a;
    }

    @media(min-width: 1400px){
        .from-layout{
            width: 30%;
        }
    }
</style>

<script>
import axios from "axios";
import config from "../../../public/js/config.js";

export default {
    name: "dashboardLogin",
    data(){
        return {
            email: "",
            password: ""
        }
    },
    methods: {
        login: function(){
            let formData = new FormData();
            formData.append('email', this.email);
            formData.append('password', this.password);

            axios.post(config.api_url() + 'dashboard/login', formData)
                .then((response) => {
                    if(response.status == 200){
                        let data = response.data;
                        if( data['status'] == true ){
                            let admin = {
                                id: data['admin'].id,
                                username: data['admin'].username,
                                email: data['admin'].email,
                                token: data['admin'].token
                            };

                            window.localStorage.setItem('admin', JSON.stringify(admin));
                            window.localStorage.removeItem('user');
                            this.$store.commit("auth/setAdmin", admin);
                            this.$store.commit("auth/setUser", null);

                            window.location.href = "/dashboard";
                        }
                        else{
                            let errorLayout = document.getElementById('status-layout');
                            errorLayout.innerHTML = "";
                            let newError = document.createElement('div');
                            newError.classList.add('alert', 'alert-danger');
                            newError.innerHTML = data['message'];
                            errorLayout.appendChild(newError);
                        }
                    }
                })
                .catch(() => {
                    console.log('error');
                });
        }
    }
}
</script>